
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { Nav, NavItem } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import AppNavBarAboutMe from './Nav_AppNavBar_AboutMe.js';
import AppNavBarMyProjects from './Nav_AppNavBar_MyProjects.js';
import AppNavBarWritingSamples from './Nav_AppNavBar_WritingSamples.js';
import AppNavBarLinkedIn from './Nav_AppNavBar_LinkedIn.js';
import AppNavBarOrganizations from './Nav_AppNavBar_Organizations.js';

/**
 * Note: Your components tell React what you want to render
 */
class AppNavBar extends React.Component {
	render() {
		return (
				<Nav bsStyle="tabs" activeKey="1">
	        <NavItem eventKey="1" href="/">Clayfoot - Tracy's Website</NavItem>

	        <AppNavBarAboutMe eventKey="2" />
	        <AppNavBarMyProjects eventKey="3" />
	        <AppNavBarWritingSamples eventKey="4" />
	        <AppNavBarLinkedIn eventKey="5" />
	        <AppNavBarOrganizations eventKey="6" />
	      </Nav>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default AppNavBar;


/*

<NavBar>
					<AppNavBarHeader title=" Tracy's Website" />
					<NavBarTarget id="navbar-app">
						<NavBarMenu>
							<NavBarDropDown linkTo="#" title="About Me">

							</NavBarDropDown>
						</NavBarMenu>
					</NavBarTarget>
				</NavBar>
*/


// WEBPACK FOOTER //
// ./src/cba/appspec/header/Nav_AppNavBar.js